import { InfoCircleSolid, PinSolid, StarSolid } from '@byway/icons';

import clsx from 'clsx';
import { forwardRef } from 'react';

const ICON_COMPONENTS = {
  info: InfoCircleSolid,
  'pin-filled': PinSolid,
  star: StarSolid
};

type TagProps = {
  type?: 'default' | 'primary' | 'glassy' | 'success' | 'custom';
  mode?: 'default' | 'primary' | 'glassy';
  size?: 'small' | 'medium' | 'large';
  as?: React.ElementType;
  label?: string;
  icon?: string;
  className?: string;
  children?: React.ReactNode;
};

const Tag = forwardRef<HTMLDivElement, TagProps>(
  ({ label, children, type = 'default', className, size = 'medium', icon, as, ...props }, ref) => {
    // legacy props
    if (props?.mode) {
      type = props.mode;
    }

    if (className) {
      type = 'custom';
    }

    const classNames = clsx(
      `rounded px-2 py-0.5 inline-flex items-center`,
      {
        'border border-neutral-400': type === 'default',
        'bg-black border border-black text-white': type === 'primary',
        'border border-neutral-300 bg-neutral-200 bg-opacity-90': type === 'glassy',
        'bg-green-200/60 text-black': type === 'success',
        'text-xs': size === 'small',
        'text-sm': size === 'medium'
      },
      className
    );

    const TagElement = as || 'div';

    return (
      <TagElement className={classNames} ref={ref} {...props}>
        <span className="inline-flex gap-1 items-center typography-chip-style">
          {!!icon &&
            (() => {
              const IconComponent = ICON_COMPONENTS[icon as keyof typeof ICON_COMPONENTS];
              return IconComponent ? <IconComponent decorative size="large" /> : null;
            })()}
          {label}
          {children}
        </span>
      </TagElement>
    );
  }
);

Tag.displayName = 'Tag';

export { Tag };
